export const separateFilePath = (fullPath: string) => {
  const lastPosition = fullPath.lastIndexOf('/')
  const file = {
    path: fullPath.substring(0, lastPosition + 1),
    name: fullPath.substring(lastPosition + 1)
  }
  return file
}
